.container {
  position: relative;
  cursor: pointer;
  width: 100%;
  display: flex;
  justify-content: center;
  transition: 0.2s ease-out;
}

.avatar {
  position: absolute;
  z-index: 100;
}

.commentPaper {
  margin-left: 10.4px;
  margin-top: 24px;
  padding: 8px;
  border-left: 2px solid var(--tuna-palette-secondary-main);
  border-radius: 0;
  display: flex;
  flex-direction: column;
  position: absolute;
}

.commentText {
  padding-bottom: 4px;
}

.commentMeta {
  color: var(--tuna-content-muted);
}

.editPaper {
  padding: 16px;
  margin-left: 9.6px;
  background-color: var(--tuna-palette-layers);
  border-left: 2px solid var(--tuna-palette-secondary-main);
  border-radius: 0;
  align-items: center;
  display: flex;
  flex-direction: row;
}

.deleteButton {
  color: var(--tuna-content-secondary);
}
